import React from "react";
import clsx from "clsx";

import ModalContainer, { ModalContainerProps } from "components/common/ModalContainer";
import { ForecastNewProductContentProps } from "./types/ForecastNewProductStepForm";
import Button from "components/common/Button";
import NewProductForecaster from "assets/images/landing/new-product-forecaster.png";
import ToggleInput from "components/common/InputField/ToggleInput";

type ForecastNewProductEnableProps = {} & ForecastNewProductContentProps &
    Omit<ModalContainerProps, "children">;

export default function ForecastNewProductEnable(props: ForecastNewProductEnableProps) {
    const { stepper, formik, tailwindClassName, ...rest } = props;

    console.log({ formik });

    return (
        <ModalContainer {...rest} tailwindClassName={clsx("max-w-[554px]", tailwindClassName)}>
            <div>
                <p className="text-[18px] px-[24px] py-[16px] font-rocGroteskMedium">
                    Enable Required AI Agent
                </p>

                <hr className="border-[#E2E8F0]" />

                <div className="px-[24px] py-[12px] bg-[#F8FAFC]">
                    <p className="text-[14px] text-[#64748B] font-[500] font-rocGroteskMedium leading-[20px]">
                        To continue, turn on the agent. This agent supports new product planning.
                        You can switch it off anytime from{" "}
                        <span className="text-[#000000] underline cursor-pointer">WorkforceIQ.</span>
                    </p>
                </div>

                <form onSubmit={formik.handleSubmit} className="my-[28px] flex justify-center">
                    <div className="w-[325px] shadow-[0px_20px_24px_-4px_rgba(16,24,40,0.08),0px_4px_8px_-4px_rgba(16,24,40,0.12)] rounded-[8px] overflow-hidden border border-[#E2E8F0]">
                        <img
                            className="w-full"
                            src={NewProductForecaster}
                            alt="NewProductForecaster"
                        />
                        <div className="px-[20px] py-[16px]">
                            <div className="flex items-center gap-[8px]">
                                <div className="w-[20px] h-[20px] rounded-full bg-[#0054C2] flex justify-center items-center">
                                    <i className="ri-robot-fill text-[#fff] text-[10px]"></i>
                                </div>
                                <p className="font-[16px] font-[500px] text-[#042821] font-rocGroteskMedium">
                                    New Product Forecaster
                                </p>
                            </div>

                            <p className="mt-[8px] font-[14px]   text-[#64748B] leading-[20px] font-rocGroteskRegular">
                                Generate forecasts for new product launches using existing product
                                and channel data
                            </p>

                            <div className="flex space-x-3 mt-[30px]">
                                <ToggleInput
                                    checked={formik.values.enableAgent}
                                    disabled={formik.isSubmitting}
                                    name="turnOnAgent"
                                    onChange={(e) => {
                                        formik.setFieldValue("enableAgent", e.target.checked);
                                    }}
                                />
                                <p className="text-[#042821] font-[14px] font-rocGroteskMedium">
                                    Turn on agent
                                </p>
                            </div>
                        </div>
                    </div>
                </form>

                <hr className="border-[#E2E8F0]" />

                <div className="flex justify-end gap-[8px] px-[24px] py-[12px]">
                    <Button
                        btnText="Cancel"
                        onClick={rest.closeModal}
                        btnClassname="!bg-[#F4F5F7] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                    <Button
                        btnText="Continue"
                        type="submit"
                        disabled={formik.isSubmitting || !formik.values.enableAgent}
                        onClick={() => {
                            formik.handleSubmit();
                        }}
                        btnClassname="!bg-[#FFB903] cursor-pointer !text-[13px] !px-[24px] !py-[12px] rounded-[5px] !h-[42px] w-min !whitespace-nowrap"
                    />
                </div>
            </div>
        </ModalContainer>
    );
}
